export default __webpack_public_path__ + "static/media/02en.ad6b7a7c.mp3";